export const environment = {
  production: true,
  apiEndpoint: 'https://api.focusro.com',
  timeout: 5000,
  imageEndpoint: 'https://screen.focusro.com/',
  appTrackingDeploymentDate: '2023-01-20',
  orgCode:["DAY","ITPA"],
  stripePublishKey:'pk_live_51HpBniKzGzvPeQOK8MIcfefo7uQs8nTWPrEkxb9miMScIlJRoIB7k9EpnDSS2FZGXJ1wWYQ3bHsiB8914WIIsMu600Lxnt9ddx',
  mobileAppOrgCode: ["frmob"],
  restApiServiceEndpoint: 'https://connect.focusro.com',
  ebdCode: 'https://cdn.focusro.com/focusro-job-posting-widget.min.js',
  turnUrl: 'myturn.focusro.com:3478',
  turnUser: 'mywebrtcuser',
  turnPass: 'mywebrtcpassword'
};
